export class DetailsOfClaimant {
  claimantTypeId: number ;
  registrationTypeId: number;
  deliveryModeId:number;
  firstName: any;
  lastName: any;
  postalAddressLine1: any;
  postalAddressLine2: string;
  postalAddressLine3: string;
  postalCountry: number;
  postalCode: string;
  isCorrespondenceSameAsPostal: boolean;
  correspondenceMailingAddressLine1: any;
  correspondenceMailingAddressLine2: string;
  correspondenceMailingAddressLine3: string;
  correspondenceMailingCountry: number;
  correspondenceMailingPostalCode: string;
  emailAddress: string;
  creditorReferenceNumber: string;
  deliveryMode: number;
  activationStatusId: number;
  isDraft: boolean;
  creditorUEN: string;
  nriC_FIN_PassportNo: string;
  liquidationUEN: string;
  createdOn: Date;
  createdBy: string;
  contactDetailsOfClaimant: ContactDetailsOfClaimant[] = [];
  countryCode: string;
  contactNumber?: string;
  companyName: any;
  engagementId: string;
  selectedCountry: string;
  selectedCorresCountry: string;
  countryName: string;
  correspondenceCountryName: string;
  id: string;
  windingUpNumber: string;
  displayName: string;
  formId: number;
  legalEntityName: string;
  correspondanceCountrySelected: boolean;
  countrySelected: boolean;
  withdrawnParticularsOfDebtId: string;
  termsAndConditionsId:string;
}

export class ContactDetailsOfClaimant {
  preOnboardingCreditorId: any;
  countryCode: string;
  contactNumber: string;
  isActive: boolean;
  createdOn: Date;
}

export const DetailsOfClaimantDataConstants= {
  DuplicateContact: "One or more duplicate contact number exists. Please remove to proceed."
 };